import { render, staticRenderFns } from "./country-old.vue?vue&type=template&id=3d74b5a8&"
import script from "./country-old.vue?vue&type=script&lang=js&"
export * from "./country-old.vue?vue&type=script&lang=js&"
import style0 from "./country-old.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports